module.exports = __webpack_public_path__ + "img/taouil.b819edb1.jpg";